"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../type/entity");
function getCompletionStatus(completionStatus) {
    switch (completionStatus) {
        case 'complete':
            return entity_1.CompletionStatus.COMPLETE;
        case 'inComplete':
            return entity_1.CompletionStatus.INCOMPLETE;
        case 'notAttempted':
        default:
            return entity_1.CompletionStatus.NOT_ATTEMPTED;
    }
}
exports.getCompletionStatus = getCompletionStatus;
//# sourceMappingURL=getCompletionStatus.js.map